module.exports = __webpack_public_path__ + "img/icon-mp4.e0b18a47.svg";